import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RouterActionService {
  private actionSubject = new Subject<any>();
  action$ = this.actionSubject.asObservable();

  emit(action: any) {
    this.actionSubject.next(action);
  }
}